<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row>
                <b-col>
                    <b-card border-variant="primary">
                        <template slot = "header">
                            <i class='fa fa-align-justify'></i>
                            Notice_Test
                        </template>
                        <b-button class="float-right mx-2 mb-3" size = "sm" variant = "outline-success" @click="$router.push({ name: 'notice_test', params: { id : 'add' } })">Registration</b-button>
                        <b-input-group size = "sm">
                            <b-input-group-prepend>
                                <b-button variant = "outline-secondary" @click = "refresh()"><i class = "fa fa-refresh"></i></b-button>
                            </b-input-group-prepend>
                        </b-input-group>
                        <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text = "not found"
                            :items = "load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
                            <template slot="id" slot-scope="row">
                                {{ startRow - row.index }}
                            </template>
                            <template slot="type" slot-scope="row">
                                {{ row.item.type.toLowerCase() }}
                            </template>
                            <template slot="title" slot-scope="row">
                                {{ row.item.title }}
                            </template>
                            <template slot="created_at" slot-scope="row">
                                {{ row.item.created_at | date }}
                            </template>
                            <template slot="more" slot-scope="row">
                                <b-button @click = "more(row.item)" size = "sm" variant="outline-primary">More</b-button>
                            </template>
                        </b-table>
                        <hr>
                        <b-row>
                            <b-col class = "md-8">
                                <b-pagination size = "sm" :total-rows = "getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text = "Prev" next-text = "Next" />
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </div>          
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { Api } from '@/service';
import moment from 'moment-timezone';
import custom from '@/custom';

const opt = () => ({
    perPage: 10,
    currentPage: 1,
    totalRows: 0,
    sk: 'title',
    sv: '',
    skt: 'title',
    opt: { type: '' }
});

export default {
    name : 'noticeTestList',
    components : { DatePicker },
    props: [ 'auto_refresh', 'user' ],

    data() {
        return {
            custom,
            so: opt(),
            custom,
            sync : { interval : 15, stop : false, th : undefined, enable : false },
            type: '',
        }
    },
    computed: {
        startRow() { 
            return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
        },

        fields() {
            return [
                { key: 'id', label: 'No', sortable: false, thStyle: 'width: 10%;'},
                { key: 'type', label: 'Solution', sortable: true},
                { key: 'title', label: 'Title', sortable: true},
                { key: 'created_at', label: 'Date', sortable: true},
                { key: 'more', label: 'More', sortable: false},
            ]
        },
    },
    
    methods: {
        getRowCount() {
            return this.so.totalRows || 0;
        },

        more: function(item) {
            this.$router.push(`notice_test/${item.id}`);
        },

        refresh() {
            console.log("refresh", this.$route.name, new Date());

            if(this.$refs._list) {
                this.$refs._list.refresh();

                if(this.sync.enable) {
                    this.sync.stop = false; this.pause();
                }
            }
        },

        set_op(k, v){
            if(v == 'false' || v == 'true') {
                return { name : k, value: v === "false" ? false : true, op : '='}
            }

            return { name: k, value: `%${v}%`, op : 'like' }
        },

        load(ctx = {}) {
            let and = [ this.set_op('is_del', 'false')]

            let so = {
                target : 'board.notice',
                cmd : 'list',
                body : { sort: [{ name: 'id', op : 'desc' }], or: [], and : and },
                offset : (this.so.currentPage - 1 || 0) * this.so.perPage,
                limit: this.so.perPage,
            }

            if(ctx.sortBy) {
                so.body.sort = [{ name : ctx.sortBy, op : !ctx.sortDesc && 'desc' }];
            }

            if(this.type) {
                so.body.and.push(this.set_op('type', this.type.value));
            }

            if(this.user) {
                so.body.and.push({ name: 'user_id', value : this.user.id, op : '=' })
            }

            return Api.Manager(so).then(rs => { this.so.totalRows = rs.total;
                return rs.body;
            }).catch(e => alert('load error'))
        },
    },

    created() {
        console.log('notice_test.list.vue', 'created');
    },
    destroyed(){
        console.log('notice_test.list.vue', 'destroyed');
    },
    mounted(){
        console.log('notice_test.detail.vue', 'mounted');

        if(this.auto_refresh == true) {
            this.sync.enable = this.auto_refresh;
        }
    },
}
</script>
